import { render, staticRenderFns } from "./PaginatorComponent.vue?vue&type=template&id=56650bd4&"
import script from "./PaginatorComponent.vue?vue&type=script&lang=js&"
export * from "./PaginatorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports